"use strict";

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var runWithConcurrency = function runWithConcurrency(concurrency, tasks) {
  return new Promise(function (resolve, reject) {
    var results = [];
    var rejected = false;
    var settled = tasks.length;

    var forRun = __spreadArrays(tasks);

    var run = function run() {
      var index = tasks.length - forRun.length;
      var next = forRun.shift();

      if (next) {
        next().then(function (result) {
          if (rejected) return;
          results[index] = result;
          settled -= 1;

          if (settled) {
            run();
          } else {
            resolve(results);
          }
        }).catch(function (error) {
          rejected = true;
          reject(error);
        });
      }
    };

    for (var i = 0; i < concurrency; i++) {
      run();
    }
  });
};

exports.default = runWithConcurrency;